package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.animation.core.copy
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.letterSpacing
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD
import waldo.sankan.lineamunicipalkmp.web.components.TipificacionDialog
import kotlin.js.Date
import kotlin.math.floor
import waldo.sankan.lineamunicipalkmp.web.components.FiscalizacionDialog
import kotlinx.browser.window
import org.w3c.files.FileReader
import org.w3c.files.get
// --- LOCAL, PRIVATE, AND DISCIPLINED HELPER FUNCTIONS ---
// These functions exist only within this file to prevent any conflicts.

private fun formatTimestamp(timestamp: Long?): String {
    if (timestamp == null) return "N/A"
    val date = Date(timestamp)
    return "${date.getDate().toString().padStart(2, '0')}/" +
           "${(date.getMonth() + 1).toString().padStart(2, '0')}/" +
           "${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}"
}

private fun formatDuration(ms: Long?): String {
    if (ms == null || ms <= 0) return "N/A"
    val totalMinutes = floor(ms / 60000.0)
    val totalHours = floor(totalMinutes / 60.0)
    val days = floor(totalHours / 24.0).toInt()
    val hours = (totalHours % 24).toInt()
    val minutes = (totalMinutes % 60).toInt()
    val parts = mutableListOf<String>()
    if (days > 0) parts.add("$days d")
    if (hours > 0) parts.add("$hours h")
    if (minutes > 0 || parts.isEmpty()) parts.add("$minutes min")
    return parts.joinToString(" ")
}

private fun formatElapsedTime(startTime: Long?): String {
    if (startTime == null) return "N/A"
    val diff = Date.now() - startTime
    return formatDuration(diff.toLong())
}

@Composable
private fun ContentBox(modifier: StyleBuilder.() -> Unit = {}, content: @Composable () -> Unit) {
    Div({
        style {
            border(1.px, LineStyle.Solid, Color("#e0e0e0"))
            borderRadius(8.px)
            padding(16.px)
            backgroundColor(Color.white)
            flex(1)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            modifier()
        }
    }) {
        content()
    }
}
// --- FUNCIÓN DE UTILIDAD PARA EL SEPARADOR DE DÍAS (VERSIÓN JS) ---
private fun esDiaDiferente(fechaActual: Long?, fechaAnterior: Long?): Boolean {
    if (fechaActual == null) return false
    if (fechaAnterior == null) return true
    val d1 = Date(fechaActual)
    val d2 = Date(fechaAnterior)
    return d1.getFullYear() != d2.getFullYear() ||
            d1.getMonth() != d2.getMonth() ||
            d1.getDate() != d2.getDate()
}
@Composable
private fun CommunicationHistoryBox(comentarios: List<waldo.sankan.lineamunicipalkmp.model.ComentarioIncidencia>) {
    Div({
        style {
            flex(1)
            height(500.px) // Altura de combate fija
            overflowY("auto")
            padding(16.px)
            backgroundColor(Color("#1976D2")) // ¡FONDO AZUL FIXO IGUAL QUE LA APP!
            borderRadius(12.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
        }
    }) {
        if (comentarios.isEmpty()) {
            Div({ style { color(rgba(255,255,255,0.6)); textAlign("center"); paddingTop(20.px) } }) {
                Text("No hay mensajes previos.")
            }
        } else {
            val mensajesOrdenados = comentarios.sortedBy { it.fecha }

            mensajesOrdenados.forEachIndexed { index, msg ->
                val fechaActual = msg.fecha
                val fechaAnterior = if (index > 0) mensajesOrdenados[index - 1].fecha else null

                // --- 1. SEPARADOR DE DÍA TIPO WHATSAPP ---
                if (esDiaDiferente(fechaActual, fechaAnterior)) {
                    Div({
                        style {
                            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); margin(16.px, 0.px)
                        }
                    }) {
                        Span({
                            style {
                                backgroundColor(rgba(255, 255, 255, 0.2))
                                color(Color.white); padding(4.px, 12.px); borderRadius(8.px)
                                fontSize(12.px); fontWeight("bold")
                            }
                        }) {
                            val d = Date(fechaActual!!)
                            Text(d.toLocaleDateString("es-CL", js("{'weekday': 'long', 'day': 'numeric', 'month': 'long'}")))
                        }
                    }
                }

                // --- 2. LÓGICA DE DISTRIBUCIÓN (QUIÉN HABLA) ---
                // En el Panel Web, el "YO" es el ADMINISTRADOR
                val esMio = msg.rolUsuario?.contains("ADMIN") == true
                val colorBurbuja = if (esMio) Color("#DCF8C6") else Color.white

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        // Si es Admin, burbuja a la derecha. Si es Ciudadano/Patrulla, a la izquierda.
                        flexDirection(if (esMio) FlexDirection.RowReverse else FlexDirection.Row)
                        alignItems(AlignItems.FlexEnd)
                        width(100.percent)
                    }
                }) {
                    // --- ICONO CIRCULAR (IGUAL QUE EN LA APP) ---
                    Div({
                        style {
                            width(35.px); height(35.px)
                            borderRadius(50.percent)
                            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                            backgroundColor(rgba(255, 255, 255, 0.2))
                            property("border", "1.px solid rgba(255,255,255,0.4)")
                            margin(if (esMio) 0.px else 8.px, if (esMio) 8.px else 0.px)
                            flexShrink(0) // No se deforma
                        }
                    }) {
                        // 1. Limpiamos el rol para el escáner
                        val rol = (msg.rolUsuario ?: "").uppercase().trim()

                        // 2. Selección de imagen (Ajustamos rutas según el error 404)
                        // Si sus imágenes están en una carpeta llamada 'img', añada "img/" al principio.
                        val iconSrc = when {
                            rol.contains("CIUDADANO") -> "ciudadanos1.png"
                            rol.contains("SOLUCIONADOR") -> "seguridad1.png"
                            rol.contains("DRON") -> "dron1.png"
                            else -> "lineamunilogo1.png"
                        }

                        Img(src = iconSrc, attrs = {
                            style {
                                width(24.px)
                                height(24.px)
                                property("object-fit", "contain")
                            }

                            // ¡VICTORIA! Esta es la sintaxis correcta para la Web
                            addEventListener("error") {
                                console.error("Falla de Suministros: No se encontró el archivo '$iconSrc' en el servidor.")
                            }
                        })
                    }

                    // --- LA BURBUJA (SHAPE WHATSAPP) ---
                    Div({
                        style {
                            maxWidth(75.percent)
                            padding(8.px, 12.px)
                            backgroundColor(colorBurbuja)
                            // Bordes asimétricos exactos de tu código de la App
                            if (esMio) {
                                borderRadius(16.px, 16.px, 0.px, 16.px)
                            } else {
                                borderRadius(16.px, 16.px, 16.px, 0.px)
                            }
                            property("box-shadow", "0px 1px 2px rgba(0,0,0,0.2)")
                            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                        }
                    }) {
                        // Nombre del Remitente
                        B({
                            style {
                                fontSize(11.px)
                                color(if (esMio) Color("#075E54") else Color("#1976D2"))
                                marginBottom(2.px)
                            }
                        }) {
                            Text(if (esMio) "Usted (Mando)" else (msg.usuarioNombre ?: "Muni Arica"))
                        }

                        // Texto del Mensaje
                        Span({
                            style { fontSize(14.px); color(Color.black); lineHeight("1.4") }
                        }) {
                            Text(msg.texto)
                        }

                        // Hora (Alineada a la derecha de la burbuja)
                        Span({
                            style {
                                fontSize(10.px); color(rgba(0,0,0,0.45))
                                alignSelf(AlignSelf.FlexEnd); marginTop(2.px)
                            }
                        }) {
                            val d = Date(msg.fecha ?: 0)
                            Text("${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}")
                        }
                    }
                }
            }
        }
    }
}

// --- FIN DE LA NUEVA FUNCIÓN ---
@Composable
fun IncidenciaDetailScreen(
    uiState: AdminPanelUiState,
    viewModel: AdminPanelViewModel,
    incidencia: Incidencia,
    rolAdmin: waldo.sankan.lineamunicipalkmp.model.Administrador?,
    onBackToPanel: () -> Unit,
    onBackToInforme: () -> Unit,
    onEstadoChange: (String, org.w3c.files.File?) -> Unit,
    mensajeParaCiudadano: String,
    onMensajeParaCiudadanoChanged: (String) -> Unit,
    onEnviarMensajeCiudadano: () -> Unit,
    mensajeParaSolucionador: String,
    onMensajeParaSolucionadorChanged: (String) -> Unit,
    onEnviarMensajeSolucionador: () -> Unit,
    mensajeParaDron: String,
    onMensajeParaDronChanged: (String) -> Unit,
    onEnviarMensajeAlDron: () -> Unit,
    mensajeParaAdmin: String,
    onMensajeParaAdminChanged: (String) -> Unit,
    onEnviarMensajeAlAdmin: () -> Unit
)
{
    // --- LÓGICA DE TRI-SOBERANÍA (ETIQUETAS DINÁMICAS) ---
    val unidadLabel = when {
        uiState.isSeguridadSelected -> "Patrulla"
        uiState.isSalvavidasSelected -> "Salvavidas"
        else -> "Cuadrilla Urbana"
    }

    val tipificacionTitulo = when {
        uiState.isSeguridadSelected -> "Seleccionar Delitos (CEAD)"
        uiState.isSalvavidasSelected -> "Detallar Incidente de Playa"
        else -> "Detallar Hallazgo Urbano"
    }

    val tipificacionBoton = when {
        uiState.isSeguridadSelected -> "TIPIFICAR / EDITAR DELITOS"
        uiState.isSalvavidasSelected -> "DETALLAR INCIDENTE DE PLAYA"
        else -> "DETALLAR HALLAZGO URBANO"
    }

    val esComunal = remember(rolAdmin) { rolAdmin?.rol == "COMUNAL" }
    val labelHallazgo = if (uiState.isSeguridadSelected) "Incidencia" else "Hallazgo"
    val labelSolucion = if (uiState.isSeguridadSelected) "Resolución" else "Solución"

    var mostrarDialogoTipificacion by remember { mutableStateOf(false) }

    var estadoSeleccionado by remember(incidencia.estado) { mutableStateOf(incidencia.estado) }
    var evidenciaSeleccionada by remember { mutableStateOf<org.w3c.files.File?>(null) }
    var urlPrevisualizacion by remember { mutableStateOf<String?>(null) }

    var elapsedTime by remember { mutableStateOf(formatElapsedTime(incidencia.fechaCreacion)) }

    var mostrarDialogoFiscalizacion by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        viewModel.cargarDatosDeGestion()
    }

    LaunchedEffect(incidencia.id) {
        if (incidencia.fechaSolucion == null) {
            while (true) {
                elapsedTime = formatElapsedTime(incidencia.fechaCreacion)
                delay(60000)
            }
        }
    }

    // --- LIENZO PRINCIPAL (PANTALLA COMPLETA AZUL) ---
    Div({
        style {
            width(100.vw)
            minHeight(100.vh)
            backgroundColor(Color("#1976D2")) // ¡EL MANTO AZUL FIXO!
            fontFamily("sans-serif")
            boxSizing("border-box")

        }
    })
    {

        // --- BARRA DE MANDO (HEADER) ---
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceBetween)
                width(100.percent)
                padding(12.px, 48.px)
                backgroundColor(Color("#1565C0")) // Un azul un poco más oscuro para el header
                property("box-shadow", "0px 2px 10px rgba(0,0,0,0.3)")
                boxSizing("border-box")
            }
        }) {
            // --- LOGO Y TEXTO A LA IZQUIERDA ---
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                }
            }) {
                Img(src = "logo_icon.svg",
                    attrs = { style { height(120.px) } })
                Div({ style { display(DisplayStyle.Flex);
                    flexDirection(FlexDirection.Column) } }) {
                    H2({
                        style {
                            fontSize(24.px)
                            color(Color.white)
                            margin(0.px)
                        }
                    }) {
                        Span({ style { fontWeight("normal") } })
                        { Text("Linea") }
                        Span({ style { fontWeight("bold") } })
                        { Text("Muni") }
                    }
                    P(attrs = {
                        attr("translate", "no")
                        // --- ¡LA CORRECCIÓN! ---
                        // El estilo ahora está DENTRO de los atributos.
                        style {
                            fontSize(16.px)
                            color(Color("#FB8C00")) // Naranja Fixo
                            fontWeight("bold")
                            letterSpacing(1.px)
                            margin(0.px)
                        }
                    }) {
                        // La formación ahora solo contiene al soldado Text.
                        Text("SMART CITY")
                    }
                }
            }
            // --- TÍTULO "DETALLE DE INCIDENCIA" ---
            H1({
                style {
                    color(Color.white)
                    fontSize(32.px)
                    fontWeight(700)
                    margin(0.px)
                    property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)")
                }
            }) {
                Text("Detalle de Incidencia")
            }

            // --- SECCIÓN DE FILTROS DE PERÍODO ---
        Div({
            style {
                display(DisplayStyle.Flex)
                gap(24.px)
                padding(16.px, 32.px)
                backgroundColor(Color("#f2f2f2"))
                alignItems(AlignItems.Center)
            }
        }) {


            Div({
                style {
                    display(DisplayStyle.Flex) // Los ordena en fila
                    gap(16.px); width(100.percent); alignItems(AlignItems.Center)
                }
            }) {
                // --- 🗺️ BOTÓN PLAN CUADRANTE ---
                Button(attrs = {
                    onClick { viewModel.onShowPlanCuadranteModal() }
                    style {
                        padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                        backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                        border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                    }
                }) { Text("🗺️ PLAN CUADRANTE") }


                if (uiState.rolAdmin?.rol == "SEGURIDAD_ADMIN") {
                    // Versión para el Comandante de Seguridad
                    Button(attrs = {onClick { viewModel.onShowEstadisticasSeguridadClicked() }
                        style {
                            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                            backgroundColor(Color("#AD1457")); borderRadius(8.px); cursor("pointer")
                            border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                        }
                    }) { Text("Estadísticas Delitos") }
                } else {
                    // Versión para el Administrador General y otros roles
                    Button(attrs = {
                        onClick { viewModel.onShowEstadisticasClicked() }
                        style {
                            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                            backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                            border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                        }
                    }) { Text("Estadísticas") }
                }

                // Reemplaza tu botón "Informes" actual por este bloque
                if (uiState.rolAdmin?.rol == "SEGURIDAD_ADMIN") {
                    Button(attrs = { onClick { viewModel.onShowInformeSeguridadClicked() }
                        style {
                            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                            backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                            border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                        }
                    }) { Text("Informes Delitos") }
                } else {
                    Button(attrs = { onClick { viewModel.onShowInformeClicked() }
                        style {
                            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                            backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                            border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                        }
                    }) { Text("Informes") }
                }

                Div({ style { flex(1) } })

                //  1: Volver al Panel (AHORA AL FINAL A LA DERECHA)
                Button(attrs = {
                    onClick { onBackToPanel() }
                    style {
                        padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                        backgroundColor(Color("#FB8C00")); borderRadius(8.px); cursor("pointer")
                        border(1.px, LineStyle.Solid, Color.black); property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
                    }
                }) { Text("Volver al Panel") }
            }
        }
        }


        // --- CONTENEDOR PRINCIPAL DEL CONTENIDO (CON PADDING) ---

        Div({ style { padding(24.px) } }) {
            Div({ style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(24.px)
            } }) {
                Div({ style {  // primera fila
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Row)
                    gap(24.px)
                    alignItems(AlignItems.Stretch)
                    height(600.px)
                }}) {
                    ///////////////////////////////////////////////
                    Div({       // columna de la izquierda.... detalles generales y cambio estado
                        style {
                            flex(1);
                            display(DisplayStyle.Flex);
                            flexDirection(FlexDirection.Column);
                            gap(16.px)
                        }})
                    {
                        Div({
                            style {
                                display(DisplayStyle.Flex);
                                flexDirection(FlexDirection.Row);
                                gap(16.px);
                                flex(1)
                            }})
                        {
                            ContentBox {
                                H3({
                                    style {
                                        marginTop(16.px) }})
                                    { Text("Detalles Generales") }
                                // --- SELLO DE ORIGEN (WEB) ---
                                P({
                                    style {
                                        display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px)
                                        margin(8.px, 0.px); padding(8.px); backgroundColor(Color("#f1f8e9"))
                                        borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#c5e1a5"))
                                    }
                                }) {
                                    B { Text("ORIGEN: ") }
// --- BLOQUE A MODIFICAR EN IncidenciaDetailScreen.kt ---
                                    // --- BLOQUE PARA PEGAR EN IncidenciaDetailScreen.kt ---
                                    val (texto, color) = when(incidencia.origenReporte) {
                                        "OPERADORA"        -> "📞 RECEPCIÓN TELEFÓNICA" to "#1A73E8"
                                        "OPERADOR_CAMARAS" -> "🎥 VIGILANCIA ESTADIO (CÁMARAS)" to "#AD1457" // <-- ¡RECALIBRADO!
                                        "DRON"             -> "🚁 VIGILANCIA AÉREA (DRON)" to "#000000"
                                        "APP_SOLUCIONADOR" -> "🛡️ DETECCIÓN EN TERRENO (PATRULLA)" to "#388E3C"
                                        else               -> "📱 APP CIUDADANA" to "#2E7D32"
                                    }

                                    Span({ style { color(Color(color)); fontWeight("bold") } }) { Text(texto) }
                                }

                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B{ Text("ID: ") };
                                    Text(incidencia.id) }
                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B { Text("Estado: ") };
                                    Text(incidencia.estado) }
                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B{ Text("Tipo: ") };
                                    Text(incidencia.tipoIncidenciaDisplayName ?: "N/A") }
                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B { Text("Comuna: ") };
                                    Text(incidencia.comunaDisplayName ?: "N/A") }



                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B { Text("Reportado por: ") };
                                    Text(incidencia.usuarioNombre ?: "N/A") }

                                if (!incidencia.creadoPorNombre.isNullOrBlank()) {
                                    P({ style { margin(4.px, 0.px); fontSize(13.px); color(Color.gray) } }) {
                                        B { Text("Generado por: ") }; Text(incidencia.creadoPorNombre!!)
                                    }
                                }

                                P({
                                    style {
                                        margin(4.px, 0.px) } }){ B { Text("Fecha Reporte: ") };
                                    Text(formatTimestamp(incidencia.fechaCreacion)) }

                                if (incidencia.fechaSolucion != null) {

                                    P({ style { margin(4.px, 0.px) } }){ B { Text("Fecha Solución: ") };
                                        Text(formatTimestamp(incidencia.fechaSolucion)) }

                                    P({ style { margin(4.px, 0.px) } }) {
                                        B { Text("Tiempo de Solución: ") }
                                        // --- ¡LA LÓGICA VICTORIOSA DE LA TABLA, AHORA AQUÍ! ---
                                        val fechaInicio = incidencia.fechaCreacion
                                        val fechaFin = incidencia.fechaSolucion
                                        if (fechaInicio != null && fechaFin != null && fechaFin >= fechaInicio) {
                                            val duracionCalculada = fechaFin - fechaInicio
                                            Text(formatDuration(duracionCalculada))
                                        } else {
                                            Text("N/A") // Si faltan datos, mostramos N/A
                                        }
                                    }


                                } else {

                                    P({ style { margin(4.px, 0.px) } }){ B { Text("Tiempo Transcurrido: ") };
                                        Text(elapsedTime) }

                                }

                                incidencia.ubicacionGPS?.let { gps ->
                                    P({ style { margin(4.px, 0.px) } }) {
                                        B { Text("Coordenadas: ") }; Text("${gps.latitude}, ${gps.longitude}")
                                    }
                                }

                                if (!incidencia.observacionAuditoria.isNullOrBlank()) {
                                    P({ style { margin(8.px, 0.px); padding(8.px); backgroundColor(Color("#FFF3E0")); borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#FFE0B2")) } }) {
                                        B { Text("Agrupación / Auditoría: ") }
                                        Span({ style { color(Color("#E65100")); fontSize(13.px); fontWeight("bold") } }) { Text(incidencia.observacionAuditoria!!) }
                                    }
                                }

                                if (!incidencia.idUsuarioSolucionadorAsignado.isNullOrBlank()) {
                                    P({ style { margin(4.px, 0.px) } }){
                                        B { Text("$unidadLabel Asignada: ") }
                                        Span({ style { color(Color("#34A853")); fontWeight("bold") } }) {
                                            val sector = incidencia.sectorIncidencia ?: "GENERAL"
                                            val nombre = incidencia.nombreSolucionadorAsignado ?: "Pendiente"
                                            Text("$sector : $nombre")
                                        }
                                    }
                                }

                                // --- SECCIÓN 1: CAMBIAR ESTADO (¡CON LÓGICA CLONADA Y VICTORIOSA!) ---
                                Div ({
                                    style {
                                        display(DisplayStyle.Flex)
                                        flexDirection(FlexDirection.Column)
                                        height(100.percent) // ¡ORDEN: Ocupa toda la altura de tu ContentBox padre!
                                    }
                                })
                                {
                                    H3({
                                    style {
                                        marginTop(32.px) } })
                                        { Text("Cambiar Estado") }

                                                // El Select AHORA solo actualiza la variable local 'estadoSeleccionado'
                                        Select(attrs = {
                                            style {
                                                padding(16.px)
                                                fontSize(16.px)
                                                borderRadius(4.px)
                                                width(100.percent)
                                            }
                                            // ¡ORDEN CORREGIDA! Solo actualizamos la variable local.
                                            onChange { event -> estadoSeleccionado = event.target.value }
                                        }) {
                                            val estados = listOf("EN_PROCESO", "SOLUCIONADO", "RECHAZADO", "VERIFICADO")
                                            estados.forEach { estado ->
                                                // ¡LA CLAVE! Se marca como 'selected' si coincide con nuestra variable.
                                                Option(value = estado, attrs = { if (estado == estadoSeleccionado) selected() }) { Text(estado) }
                                            }
                                        }

                                    if (estadoSeleccionado == "SOLUCIONADO" && incidencia.urlImagenSolucion == null) {
                                        Div({ style { marginTop(16.px); marginBottom(16.px) } }) {
                                            Label(forId = "evidencia-solucion") {
                                                B { Text("Evidencia Fotográfica Obligatoria:") }
                                            }
                                            Input(type = InputType.File, attrs = {
                                                id("evidencia-solucion")
                                                style { width(100.percent); marginTop(8.px) }
                                                onChange { event ->
                                                    val file = event.target.files?.item(0)
                                                    if (file != null) {
                                                        evidenciaSeleccionada = file
                                                        val reader = FileReader()
                                                        reader.onload = { e ->
                                                            // Forzamos la actualización de la previsualización
                                                            val result = reader.result as String
                                                            urlPrevisualizacion = result
                                                        }
                                                        reader.readAsDataURL(file)
                                                    } else {
                                                        evidenciaSeleccionada = null
                                                        urlPrevisualizacion = null
                                                    }
                                                }
                                            })
                                        }
                                    }

                                    Div({ style { flexGrow(1) } })
                                                // El Botón AHORA tiene la responsabilidad de enviar la orden.
                                            Button(attrs = {
                                            onClick { onEstadoChange(estadoSeleccionado, evidenciaSeleccionada) } // ¡Llama a la función del ViewModel con el estado seleccionado!

                                            // La condición para deshabilitar ahora funciona, porque el estado de la incidencia
                                            // no cambia hasta que se presiona el botón.
                                            val faltaEvidencia = estadoSeleccionado == "SOLUCIONADO" && incidencia.urlImagenSolucion == null && evidenciaSeleccionada == null
                                            if (estadoSeleccionado == incidencia.estado || faltaEvidencia) { disabled() }

                                            style {
                                                width(100.percent)
                                                padding(12.px)
                                                fontSize(18.px)
                                                fontWeight("bold")
                                                color(Color.white)
                                                backgroundColor(if (estadoSeleccionado != incidencia.estado && !faltaEvidencia) Color("#1A73E8") else Color.gray)
                                                borderRadius(8.px)
                                                cursor(if (estadoSeleccionado != incidencia.estado && !faltaEvidencia) "pointer" else "not-allowed")
                                                marginTop(32.px)
                                            }
                                        }) { Text("Confirmar Cambio de Estado") }
                                    }
                            }
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

                            if (!esComunal) {
                                ContentBox({
                                    flex(1) // Permite que la caja ocupe el espacio vertical
                                }) {
                                    // --- ¡UN DIV ORGANIZADOR PARA APILAR ELEMENTOS! ---
                                    Div({
                                        style {
                                            display(DisplayStyle.Flex)
                                            flexDirection(FlexDirection.Column)
                                            height(500.px)
                                            gap(4.px);
                                            overflowY("auto");
                                            paddingRight(8.px);
                                            paddingTop(16.px);
                                            paddingBottom(20.px)
                                        }
                                    }) {
                                        // --- SECCIÓN 1: ASIGNACIÓN DE UNIDAD ---
                                        H3({
                                            style {
                                                color(Color.black);
                                                margin(0.px, 0.px, 8.px, 0.px);
                                                fontSize(18.px)
                                            }
                                        }) { Text("Asignación de $unidadLabel") }

                                        var sectorSeleccionado by remember { mutableStateOf("") }
                                        var patrullaSeleccionada by remember { mutableStateOf("") }
                                        var buscarRefuerzos by remember { mutableStateOf(false) }

                                        val patrullasDelSector = remember(
                                            sectorSeleccionado,
                                            buscarRefuerzos,
                                            uiState.solucionadores,
                                            incidencia.tipoIncidenciaRef
                                        ) {
                                            uiState.solucionadores.filter { sol ->
                                                val tipoIncidDisplayName =
                                                    (incidencia.tipoIncidenciaDisplayName ?: "").uppercase()
                                                val idMasterDimao = "Xx9dXIOJmX6NQgc2a2kj"

                                                // --- 🛡️ DETECCIÓN DEL PARAGUAS DE SERVICIOS URBANOS ---
                                                val esServiciosUrbanosIncidencia =
                                                    tipoIncidDisplayName.contains("BASURA") ||
                                                            tipoIncidDisplayName.contains("BACHE") ||
                                                            tipoIncidDisplayName.contains("ASEO") ||
                                                            tipoIncidDisplayName.contains("ILUMINA") ||
                                                            tipoIncidDisplayName.contains("SEM") ||
                                                            tipoIncidDisplayName.contains("AUTO") ||
                                                            incidencia.tipoIncidenciaRef == idMasterDimao ||
                                                            incidencia.tipoIncidenciaRef == "QfPdJJfAMM6PjMXeivJu" ||
                                                            incidencia.tipoIncidenciaRef == "kL2Ddyw20OJHsX3iOnNA"

                                                // 1. Inteligencia de Especialidad: Patrullas Master de Servicios Urbanos pueden atender cualquier micro-servicio
                                                val esDeEstaEspecialidad = if (esServiciosUrbanosIncidencia) {
                                                    sol.tipoIncidenciaAsignadoRef == idMasterDimao ||
                                                            sol.tipoIncidenciaAsignadoRef == incidencia.tipoIncidenciaRef
                                                } else {
                                                    sol.tipoIncidenciaAsignadoRef == incidencia.tipoIncidenciaRef
                                                }

                                                val estaActivo = sol.estaActivo
                                                val sectorMatch =
                                                    buscarRefuerzos || (sectorSeleccionado.isNotBlank() && sol.sectorAsignado == sectorSeleccionado)

                                                esDeEstaEspecialidad && estaActivo && sectorMatch
                                            }
                                        }

                                        // 1. SECTOR (Eliminamos etiqueta P para quitar márgenes)
                                        Div({ style { marginBottom(8.px) } }) {
                                            B({ style { fontSize(16.px) } })
                                            { Text("1. Seleccione el Sector:") }
                                            // --- 🛡️ FILTRADO INTELIGENTE (VERSIÓN CORREGIDA SIN CRUCE DE CABLES) ---
                                            val sectoresFiltrados = uiState.sectores.filter { sector ->
                                                val tipoIncidDisplayName =
                                                    (incidencia.tipoIncidenciaDisplayName ?: "").uppercase()

                                                // 1. Detección Blindada del Paraguas de Servicios Urbanos (Raíces de palabras)
                                                val esServiciosUrbanosIncidencia =
                                                    tipoIncidDisplayName.contains("BASURA") ||
                                                            tipoIncidDisplayName.contains("BACHE") ||
                                                            tipoIncidDisplayName.contains("ILUMINA") ||
                                                            tipoIncidDisplayName.contains("SEM") ||
                                                            tipoIncidDisplayName.contains("AUTO") ||
                                                            incidencia.tipoIncidenciaRef == "Xx9dXIOJmX6NQgc2a2kj"

                                                // 2. Detección Blindada de Seguridad
                                                val esSeguridadIncidencia =
                                                    tipoIncidDisplayName.contains("SEGURIDAD") ||
                                                            tipoIncidDisplayName.contains("VIGILANCIA") ||
                                                            tipoIncidDisplayName.contains("DELITO")

                                                when {
                                                    esServiciosUrbanosIncidencia -> {
                                                        // Solo sectores de Servicios Urbanos o la Matriz Unificada
                                                        sector.tipoRef == "TERRITORIO_ESTANDAR" ||
                                                                sector.tipoRef == "Xx9dXIOJmX6NQgc2a2kj" ||
                                                                sector.tipoDisplay.uppercase().contains("ASEO") ||
                                                                sector.tipoDisplay.uppercase().contains("URBANO") ||
                                                                sector.tipoDisplay.uppercase().contains("DIMAO")
                                                    }

                                                    esSeguridadIncidencia -> {
                                                        // Solo sectores de Seguridad o la Matriz Unificada
                                                        sector.tipoRef == "TERRITORIO_ESTANDAR" ||
                                                                sector.tipoDisplay.uppercase().contains("SEGURIDAD") ||
                                                                sector.tipoRef == incidencia.tipoIncidenciaRef
                                                    }

                                                    else -> {
                                                        // Fallback: Coincidencia exacta o Matriz Unificada
                                                        sector.tipoRef == "TERRITORIO_ESTANDAR" ||
                                                                sector.tipoRef == incidencia.tipoIncidenciaRef
                                                    }
                                                }
                                            }

                                            Select({
                                                style {
                                                    width(100.percent)
                                                    padding(8.px) // Padding reducido
                                                    fontSize(16.px)
                                                    marginTop(6.px)
                                                }
                                                onChange { event ->
                                                    sectorSeleccionado = event.target.value
                                                    patrullaSeleccionada = ""
                                                }
                                            }) {
                                                Option(value = "") { Text("Seleccionar un sector...") }
                                                sectoresFiltrados.forEach { sector ->
                                                    Option(
                                                        value = sector.nombre,
                                                        attrs = { if (sector.nombre == sectorSeleccionado) selected() }) { Text(sector.nombre) }
                                                }
                                            }
                                        }

                                        // CHECKBOX REFUERZOS (APRETADO CONTRA EL SELECT ANTERIOR)
                                        Div({
                                            style {
                                                width(100.percent)
                                                padding(8.px) // Padding reducido
                                                fontSize(16.px)
                                                //                 marginTop(6.px)
                                            }
                                        }) {
                                            Input(type = InputType.Checkbox, attrs = {
                                                id("refuerzos-checkbox")
                                                checked(buscarRefuerzos)
                                                onChange { buscarRefuerzos = it.value }
                                                style { width(16.px); height(16.px) }
                                            })
                                            Label(forId = "refuerzos-checkbox") {
                                                Span({ style { fontSize(14.px) } })
                                                { Text("Refuerzos de toda la comuna") }
                                            }
                                        }

                                        Div({ style { marginBottom(12.px) } }) {
                                            B({ style { fontSize(16.px) } })
                                            { Text("2. Seleccione la $unidadLabel:") }
                                            Select({
                                                style {
                                                    width(100.percent)
                                                    padding(8.px) // Padding reducido
                                                    fontSize(16.px)
                                                    marginTop(6.px)
                                                }
                                                if (sectorSeleccionado.isBlank() && !buscarRefuerzos) {
                                                    disabled()
                                                }
                                                onChange { event -> patrullaSeleccionada = event.target.value }
                                            }) {
                                                Option(value = "") {
                                                    Text(
                                                        if (sectorSeleccionado.isBlank() && !buscarRefuerzos) "Elija un sector" else "Seleccionar $unidadLabel..."
                                                    )
                                                }
                                                patrullasDelSector.forEach { patrulla ->
                                                    val uid = patrulla.uidAuth ?: ""
                                                    Option(
                                                        value = uid,
                                                        attrs = { if (uid == patrullaSeleccionada) selected() }) {
                                                        // 🛡️ RECALIBRADO: Mostramos el sector para evitar confusión
                                                        Text("${patrulla.sectorAsignado ?: "GENERAL"} : ${patrulla.nombre ?: "Sin Nombre"}")
                                                    }
                                                }
                                            }
                                        }

                                        val isAsignacionValida = patrullaSeleccionada.isNotBlank()
                                        Button({
                                            onClick {
                                                if (isAsignacionValida) {
                                                    val patrulla =
                                                        uiState.solucionadores.find { it.uidAuth == patrullaSeleccionada }
                                                    viewModel.onAsignarIncidencia(
                                                        incidenciaId = incidencia.id,
                                                        solucionadorUid = patrullaSeleccionada,
                                                        nombreSolucionador = patrulla?.nombre ?: "N/A",
                                                        nombreSector = sectorSeleccionado
                                                    )
                                                }
                                            }
                                            if (!isAsignacionValida) {
                                                disabled()
                                            }
                                            style {
                                                width(100.percent);
                                                padding(8.px);
                                                fontSize(18.px);
                                                fontWeight("bold");
                                                color(Color.white)
                                                backgroundColor(if (isAsignacionValida) Color("#1A73E8") else Color("#9E9E9E"))
                                                borderRadius(8.px);
                                                cursor(if (isAsignacionValida) "pointer" else "not-allowed")
                                            }
                                        }) { Text("Asignar Incidencia a $unidadLabel") }


                                        // --- SECCIÓN 2: TIPIFICACIÓN Y PROCEDIMIENTOS (NUEVA DOCTRINA) ---

                                        Div({
                                            style {
                                                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                                                height(100.percent); gap(12.px)
                                            }
                                        }) {
                                            H3({ style { marginTop(16.px) } }) { Text("Gestión Operativa") }
                                            if (uiState.isSeguridadSelected) {
                                                // --- VISOR DE INTELIGENCIA (DATOS ACTUALES) ---
                                                Div({
                                                    style {
                                                        padding(12.px); backgroundColor(Color("#f8f9fa"))
                                                        borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#eee"))
                                                    }
                                                }) {
                                                    P({ style { margin(0.px) } }) {
                                                        B { Text("Delitos: ") }
                                                        Text(
                                                            if (incidencia.tipificacionesDelito.isEmpty()) "Sin tipificar" else incidencia.tipificacionesDelito.joinToString(
                                                                ", "
                                                            )
                                                        )
                                                    }
                                                    Hr()
                                                    P({ style { margin(4.px, 0.px) } }) {
                                                        B { Text("Fiscalizaciones: ") }; Text("${incidencia.cantidadFiscalizaciones}")
                                                    }
                                                    P({ style { margin(4.px, 0.px) } }) {
                                                        B { Text("Controles Identidad: ") }; Text("${incidencia.cantidadControlesIdentidad}")
                                                    }
                                                    P({
                                                        style {
                                                            margin(4.px, 0.px);
                                                            color(if (incidencia.huboDetenidos) Color.red else Color.black)
                                                        }
                                                    }) {
                                                        B { Text("Detenidos: ") }; Text("${incidencia.cantidadDetenidos}")
                                                    }

                                                }



                                                Div({ style { flexGrow(1) } }) // Empujador

                                                // --- BOTÓN 1: TIPIFICAR DELITOS (AZUL) ---
                                                Button({
                                                    style {
                                                        width(100.percent); padding(12.px); fontSize(16.px); fontWeight(
                                                        "bold"
                                                    )
                                                        color(Color.white); backgroundColor(Color("#1A73E8")); borderRadius(
                                                        8.px
                                                    ); cursor("pointer")
                                                    }
                                                    onClick { mostrarDialogoTipificacion = true }
                                                }) { Text(tipificacionBoton) }

                                                // --- BOTÓN 2: PROCEDIMIENTOS Y CONTROL (VERDE) ---
                                                Button({
                                                    style {
                                                        width(100.percent); padding(12.px); fontSize(16.px); fontWeight(
                                                        "bold"
                                                    )
                                                        color(Color.white); backgroundColor(Color("#388E3C")); borderRadius(
                                                        8.px
                                                    ); cursor("pointer")
                                                    }
                                                    onClick { mostrarDialogoFiscalizacion = true }
                                                }) { Text("REGISTRAR PROCEDIMIENTOS") }

                                            } else {
                                                Div({
                                                    style {
                                                        padding(12.px); backgroundColor(Color("#f8f9fa"))
                                                        borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#eee"))
                                                    }
                                                }) {
                                                    P({ style { margin(0.px) } }) {
                                                        B { Text("Detalle Incidencia: ") }
                                                        Text(
                                                            if (incidencia.tipificacionesDelito.isEmpty()) "Sin tipificar" else incidencia.tipificacionesDelito.joinToString(
                                                                ", "
                                                            )
                                                        )
                                                    }
                                                }

                                                Div({ style { flexGrow(1) } }) // Empujador

                                                // --- BOTÓN 1: TIPIFICAR DELITOS (AZUL) ---
                                                Button({
                                                    style {
                                                        width(100.percent); padding(12.px); fontSize(16.px); fontWeight(
                                                        "bold"
                                                    )
                                                        color(Color.white); backgroundColor(Color("#1A73E8")); borderRadius(
                                                        8.px
                                                    ); cursor("pointer")
                                                    }
                                                    onClick {
                                                        mostrarDialogoTipificacion = true
                                                    }
                                                }) { Text(tipificacionBoton) }
                                            }
                                        }
                                    } // 5. Cierra el Div que contiene los 2 ContentBoxes (Inner Row)
                                }
                            }
                            // Columna Derecha (Evidencia y Ubicación)

                    Div({
                        style {
                            flex(2)
                            display(DisplayStyle.Flex);
                            flexDirection(FlexDirection.Column);
                            gap(16.px)
                        }
                    }) {
                        ContentBox {
                            H3({
                                style {
                                    marginTop(10.px)

                                }})
                            { Text("Evidencia y Ubicación") }

                            Div({
                                style {
                                    display(DisplayStyle.Flex);
                                    flexDirection(FlexDirection.Row);
                                    gap(16.px);
                                    alignItems(AlignItems.Stretch)
                                    flex(1)
                                }}) {
                                Div({
                                    style {
                                        flex(1);
      //                                  height(400.px)
                                    }}) {
                                    H4({
                                        style{
                                            margin(0.px,0.px,8.px,0.px)}})
                                    {Text("Antes ($labelHallazgo)")}
                                    if (incidencia.urlImagen != null) {
                                        Img(src = incidencia.urlImagen!!, alt = "Imagen Antes")
                                        { style {
                                            width(100.percent);
                                            height(90.percent);
                                            property("object-fit", "cover"); borderRadius(8.px) } }
                                    } else {
                                        P({
                                            style{
                                                fontStyle("italic")}})
                                        { Text("No hay imagen.") }
                                    }
                                }
                                Div({
                                    style {
                                        flex(1);

                                    }}) {
                                    H4({
                                        style{
                                            margin(0.px,0.px,8.px,0.px)}})
                                    {Text("Después ($labelSolucion)")}
                                    
                                    if (incidencia.urlImagenSolucion != null) {
                                        Img(src = incidencia.urlImagenSolucion!!, alt = "Imagen Después") { style { width(100.percent); height(90.percent); property("object-fit", "cover"); borderRadius(8.px) } }
                                        P({ style { fontSize(12.px); color(Color("#666")); marginTop(4.px) } }) {
                                            Text("Capturada el: ${formatTimestamp(incidencia.fechaSolucion)}")
                                        }
                                    } else if (urlPrevisualizacion != null) {
                                        // PREVISUALIZACIÓN DE ARCHIVO LOCAL SELECCIONADO
                                        Img(src = urlPrevisualizacion!!, alt = "Previsualización") { 
                                            style { 
                                                width(100.percent); 
                                                height(90.percent); 
                                                property("object-fit", "cover"); 
                                                borderRadius(8.px);
                                                border(2.px, LineStyle.Dashed, Color("#1A73E8")) 
                                            } 
                                        }
                                        P({ style { fontSize(12.px); color(Color("#1A73E8")); fontWeight("bold"); marginTop(4.px) } }) {
                                            Text("📸 Previsualización: Lista para subir")
                                        }
                                    } else {
                                        P({
                                            style{
                                                fontStyle("italic")}})
                                        { Text("Evidencia pendiente.") }
                                    }
                                }
                                Div({
                                    style {
                                        flex(1);
                                    }}) {
                                    H4({
                                        style{
                                            margin(0.px,0.px,8.px,0.px)}})
                                    {Text("Verificación Dron")}

                                    // --- ¡PROTOCOLO DE MANEJO SEGURO! ---
                                    // Usamos 'let' para crear una copia local e inmutable de la URL.
                                    // Esto le garantiza al compilador que la URL no será nula dentro de este bloque.
                                    incidencia.urlImagenVerificacionDron?.let { droneUrl ->
                                        Img(src = droneUrl, alt = "Verifica Dron") {
                                            style {
                                                width(100.percent);
                                                height(90.percent);
                                                property("object-fit", "cover");
                                                borderRadius(8.px)
                                            }
                                        }
                                    } ?: run {
                                        // Si la URL es nula, se ejecuta este bloque.
                                        P({
                                            style{
                                                fontStyle("italic")}})
                                        { Text("No hay imagen.") }
                                    }
                                }

                                Div({
                                    style {
                                        flex(1);
                                    }}) {
                                    H4({
                                        style{
                                            margin(0.px,0.px,8.px,0.px)}})
                                    {Text("Ubicación")}

                                    // --- ¡INTÉRPRETE UNIVERSAL ACTIVADO! ---
                                    // Usamos 'let' para trabajar de forma segura con el valor no nulo.

                                    incidencia.ubicacionGPS?.let { gps ->
                                        // Si 'ubicacionGPS' no es nulo, lo usamos directamente.
                                        val mapUrl = "https://maps.google.com/maps?q=${gps.latitude},${gps.longitude}&hl=es&z=15&output=embed"
                                        Iframe(attrs = {
                                            attr("src", mapUrl)
                                            style {
                                                width(100.percent);
                                                height(90.percent);
                                                border(0.px);
                                                borderRadius(8.px) }
                                        })
                                    } ?: run {
                                        // Si 'ubicacionGPS' ES NULO, se ejecuta este bloque 'run'.
                                        // Aquí mostramos el mensaje "No hay mapa."
                                        P({
                                            style{
                                                fontStyle("italic")}})
                                        { Text("No hay datos de mapa para mostrar.") }
                                    }
                                }
                            }
                        }
                    } //fin columna derecha.... evidencias fotos antes y despues  y el mapa de la ubicacion d ela incidencia
                }  //cierre primera fila

//////////////////////// SEGUNDA FILA DE LAS CONVERSACIONES ////////////////////////////////////

                Div({ style { //segunda fila
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Row)
                    maxHeight(350.px)
                    gap(24.px)
                    width(100.percent)
                    alignItems(AlignItems.FlexStart)
                }}) {


                    ContentBox({
                        flex(1)
                        height(250.px)
                    }) {
                        H3({ style { marginTop(0.px) }}) { Text("Historial de Comunicaciones") }

                        CommunicationHistoryBox(incidencia.comentarios)

                    }
// --- BLOQUE DINÁMICO DE MENSAJERÍA (AJUSTADO POR ROL) ---
                    val esCamara = rolAdmin?.rol == "OPERADOR_CAMARAS"

// 1. CAJA DE COMUNICACIÓN CON EL MANDO (CIUDADANO O ADMIN)
                    ContentBox({ flex(1); height(250.px); maxHeight(350.px) }) {
                        H3({ style { marginTop(0.px) } }) {
                            Text(if (esCamara) "Enviar Mensaje al Panel de Control (Admin)" else "Enviar Mensaje al Ciudadano")
                        }
                        TextArea(
                            value = if (esCamara) uiState.mensajeParaAdmin else mensajeParaCiudadano,
                            attrs = {
                                style { height(200.px); boxSizing("border-box") }
                                placeholder(if (esCamara) "Informa hallazgo al administrador..." else "Escribe al ciudadano...")
                                onInput {
                                    if (esCamara) viewModel.onMensajeParaAdminChanged(it.value)
                                    else onMensajeParaCiudadanoChanged(it.value)
                                }
                            }
                        )
                        Button(attrs = {
                            onClick {
                                if (esCamara) viewModel.enviarMensajeAlAdmin(incidencia.id)
                                else onEnviarMensajeCiudadano()
                            }
                            style {
                                padding(14.px); fontSize(16.px); fontWeight("bold"); color(Color.white)
                                backgroundColor(Color("#1A73E8")); borderRadius(8.px); cursor("pointer")
                            }
                        }) {
                            Text(if (esCamara) "Enviar al Administrador" else "Enviar a Ciudadano")
                        }
                    }



                    ContentBox({
                        flex(1)
                        height(250.px)
                    }) {
                        H3({
                            style {
                                marginTop(0.px) }})
                        { Text("Enviar Mensaje al Solucionador") }
                        TextArea(
                            value = mensajeParaSolucionador,
                            attrs = {
                                style {
                                    height(200.px);
                                    boxSizing("border-box") }
                                    placeholder("Escribe un mensaje o instrucción para el equipo solucionador...")
                                onInput { onMensajeParaSolucionadorChanged(it.value) }
                            }
                        )
                        Button(attrs = { onClick { onEnviarMensajeSolucionador() }

                            style {
                                padding(14.px)
                                fontSize(16.px)
                                fontWeight("bold") // Texto más decidido
                                color(Color.white)
                                backgroundColor(Color("#1A73E8")) // Un azul más corporativo
                                borderRadius(8.px) // Bordes redondeados, clave de Fixo
                                cursor("pointer")
                                property("transition", "background-color 0.3s") // Usamos 'property' para transiciones
                            }
                        })
                        { Text("Enviar a Solucionador") }
                    }



                    ContentBox({
                        flex(1)
                        height(250.px)
                    }) {
                        H3({
                            style {
                                marginTop(0.px) }})
                        { Text("Enviar Mensaje al Operador de Dron") }
                        TextArea(
                            value = mensajeParaDron,
                            attrs = {
                                style {
                                    height(200.px);
                                    boxSizing("border-box") }
                                placeholder("Escribe un mensaje o instrucción para el operador de dron...")
                                onInput { onMensajeParaDronChanged(it.value) }
                            }
                        )


                        Button(
                            attrs = {
                                onClick { onEnviarMensajeAlDron()}
                                style {
                                    padding(14.px)
                                    fontSize(16.px)
                                    fontWeight("bold") // Texto más decidido
                                    color(Color.white)
                                    backgroundColor(Color("#1A73E8")) // Un azul más corporativo
                                    borderRadius(8.px) // Bordes redondeados, clave de Fixo
                                    cursor("pointer")
                                    property("transition", "background-color 0.3s") // Usamos 'property' para transiciones
                                }
                            }
                        )
                        { Text("Enviar a Operador de Dron") }
                    }
                }
            }
                    if (mostrarDialogoTipificacion) {
                        TipificacionDialog(
                            titulo = tipificacionTitulo,
                            catalogoDelitos = uiState.catalogoDisponibleParaDetalle.filter { it.estaActivo },
                            seleccionActual = incidencia.tipificacionesDelito,
                            onDismiss = { mostrarDialogoTipificacion = false },
                            onConfirm = { nuevas ->
                                mostrarDialogoTipificacion = false
                                viewModel.actualizarTipificaciones(incidencia.id, nuevas)
                            }
                        )
                    }
                    if (mostrarDialogoFiscalizacion) {
                        FiscalizacionDialog(
                            titulo = "REGISTRO DE PROCEDIMIENTOS",
                            detenidosInicial = incidencia.cantidadDetenidos,
                            controlesInicial = incidencia.cantidadControlesIdentidad,
                            fiscalizacionesInicial = incidencia.cantidadFiscalizaciones,
                            onDismiss = { mostrarDialogoFiscalizacion = false },
                            onConfirm = { det, cont, fisc ->
                                mostrarDialogoFiscalizacion = false
                                viewModel.actualizarProcedimientosWeb(incidencia.id, det, cont, fisc)
                            }
                        )
                    }
                }
            }
        }
    }
}
